import React, { useEffect, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import CipHeader from "../Components/CipHeader";
import { Modal } from "react-responsive-modal";
import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import managementService from "../services/management-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import moment from "moment";
import cogoToast from "cogo-toast";

const tablePropsInit = {
  columns: [
    { key: "parents", title: "Parent Facility" },
    { key: "groupCodes", title: "Group Code" },
    { key: "chargeCodes", title: "Charge Code" },
    { key: "month", title: "Month" },
    { key: "year", title: "Year" },
    { key: "inmate", title: "Inmate Count" },
    { key: "medSurge", title: "Med Surge" },
    { key: "destroyedAmount", title: "Destroyed Amount" },
    { key: "createdAt", title: "Created On" },
    { key: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const ManagementReport = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [repList, setRepList] = useState([]);
  const [selectedReport, setSelectedReport] = useState('');
  const [open, setOpen] = useState(false);
  const onCloseModal = () => {
    setOpen(false);
    setSelectedReport('');
  };
  const downloadReport = async (
    id,
    reportMonth,
    reportYear,
    reportName,
    typeOfFile
  ) => {
    let monthName = moment("01-" + reportMonth + "-2021", "DD-MM-YYYY").format(
      "MMMM"
    );
    let filePrefix = (Array(6 + 1).join("0") + id).slice(-6);
    let fileName =
      reportName +
      monthName +
      reportYear +
      "ManagementReportMR" +
      filePrefix +
      ".xlsx";
    let params = {
      id: id,
      fileName: fileName,
    };
    if (typeOfFile === "excel") {
      setLoading(true);
      try {
        await managementService.reportDownload(params);
        setLoading(false);
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error downloading report. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
      }
    } else {
      return false;
    }
  };
  const deleteReport = async (reportId) => {
    try {
      await managementService.deleteReport(reportId);
      let resp = await managementService.getReports();
      dispatch1(updateData(resp));
      setRepList(resp);
      setOpen(false);
      setSelectedReport("");
      const { hide } = cogoToast.success("Report deleted successfully.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error deleting report. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const CustomCell = ({ rowData }) => {
    return (
      <div>
        <span className="inline-block mr-3 hidden">
          <img
            src="./img/downloadpdf.svg"
            className="mt-1 w-6 h-6 cursor-not-allowed"
            alt="Download"
            title="Download"
            onClick={(e) => {
              downloadReport(
                rowData.id,
                rowData.month,
                rowData.year,
                rowData.name,
                "pdf"
              );
            }}
          />
        </span>
        <span className="inline-block">
          <img
            src="./img/downloadxlsx.svg"
            className="mt-1 w-6 h-6 cursor-pointer"
            alt="Download"
            title="Download"
            onClick={(e) => {
              downloadReport(
                rowData.id,
                rowData.month,
                rowData.year,
                rowData.name,
                "excel"
              );
            }}
          />
        </span>
        <button
          onClick={(e) => {
            setSelectedReport(
              rowData.id
            );
            setOpen(true);
          }}
          className="inline-block ml-6"
        >
          <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="w-6 h-7">
            <g id="Nposbg.tif"><path fill="#ef082e" d="M15.51,0h1a.12.12,0,0,0,.08,0,4.32,4.32,0,0,1,3.68,3.57c0,.17.1.23.26.22.44,0,.88,0,1.32,0,1.27,0,2.54,0,3.8,0a3.59,3.59,0,0,1,3.22,2.91A3.74,3.74,0,0,1,27,10.91a.5.5,0,0,0-.33.54q0,8.39,0,16.78A3.64,3.64,0,0,1,23,32q-7,0-14,0a3.58,3.58,0,0,1-1.51-.34,3.52,3.52,0,0,1-2.13-3.41c0-5.61,0-11.23,0-16.84,0-.2,0-.34-.24-.44A3.76,3.76,0,0,1,3.28,6.3,3.67,3.67,0,0,1,6.86,3.83c1.52,0,3,0,4.56,0,.19,0,.3,0,.34-.25A4.13,4.13,0,0,1,14,.49,10.56,10.56,0,0,1,15.51,0ZM7.12,11.35v.32q0,8.24,0,16.49a1.91,1.91,0,0,0,2.09,2.09q6.8,0,13.58,0a2.56,2.56,0,0,0,.62-.05,1.92,1.92,0,0,0,1.47-2.05V11.35ZM16,5.56H6.86a1.89,1.89,0,0,0-1.77.95,2.05,2.05,0,0,0,0,2.15A2,2,0,0,0,7,9.6H25.22a2,2,0,0,0,1.87-2.74,1.94,1.94,0,0,0-2-1.29Zm2.51-1.75A2.55,2.55,0,0,0,16,1.74a2.51,2.51,0,0,0-2.46,2.07Z"/><path fill="#ef082e" d="M15.14,22.31c0-1.6,0-3.2,0-4.81a.86.86,0,0,1,1.25-.85.88.88,0,0,1,.49.87v9.56a.88.88,0,0,1-1.16.91.89.89,0,0,1-.58-.93Z"/><path fill="#ef082e" d="M10.5,22.28V17.47a.86.86,0,0,1,.95-.91.85.85,0,0,1,.75.69,2.31,2.31,0,0,1,0,.37V27a1.57,1.57,0,0,1-.08.52.85.85,0,0,1-.89.53.86.86,0,0,1-.75-.8c0-.11,0-.23,0-.34Z"/><path fill="#ef082e" d="M21.51,22.3c0,1.62,0,3.23,0,4.84A.85.85,0,0,1,20.4,28a.8.8,0,0,1-.59-.7,3.1,3.1,0,0,1,0-.43V17.72c0-.12,0-.25,0-.37a.86.86,0,0,1,1.71,0c0,1.21,0,2.42,0,3.62Z" /></g></svg>
        </button>
      </div>
    );
  };
  const CustomCell2 = ({ rowData }) => {
    return (
      <div>
        {rowData?.month
          ? moment("01-" + rowData.month + "-2021", "DD-MM-YYYY").format("MMMM")
          : ""}
      </div>
    );
  };
  const CustomCell3 = ({ rowData }) => {
    return (
      <div>
        {rowData?.createdAt
          ? moment(rowData?.createdAt).format("MM/DD/YYYY")
          : ""}
      </div>
    );
  };
  const CustomCell4 = ({ rowData }) => {
    return (
      <div className="truncate w-36" title={`${rowData?.chargeCodes}`}>
        {rowData?.chargeCodes}
      </div>
    );
  };
  const CustomCell5 = ({ rowData }) => {
    return (
      <div className="truncate w-36" title={`${rowData?.groupCodes}`}>
        {rowData?.groupCodes}
      </div>
    );
  };
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const dispatch1 = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      try {
        setLoading(true);
        let resp = await managementService.getReports();
        resp.sort(
          (d1, d2) =>
            new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
        );
        setLoading(false);
        setRepList(resp);
        dispatch1(updateData(resp));
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving Reports. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    }
  };
  useEffect(() => {
    setTimeout(async function () {
      let resp = await managementService.getReports();
      if (repList.length !== resp.length) {
        dispatch1(updateData(resp));
        setRepList(resp);
      }
    }, 30000);
  }, [repList]);

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <Modal open={open} onClose={onCloseModal} center>
        <div className="pt-10 px-8 pb-4 ">
          <h3
            className="text-lg leading-6 font-medium text-gray-900 text-center"
            id="modal-headline"
          >
            Are you sure you want to delete?
          </h3>
          <div className="flex justify-center">
            <button
              onClick={() => deleteReport(selectedReport)}
              type="button"
              className="mr-0.5 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Yes
            </button>

            <button
              onClick={() => {
                setOpen(false);
              }}
              type="button"
              className="rounded font-medium h-10 text-white w-auto px-4 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
          </div>
          {/*
           */}
        </div>
      </Modal>
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">MANAGEMENT REPORTS</span>
          </div>
          <div className="w-full sm:w-1/2 text-right flex justify-end flex-wrap ">
            <span className="mb-3">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch1(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 h-8 mr-3 focus:outline-none focus:none pl-2 w-11/12"
              />
            </span>
            <span className="text-white py-2 px-2 bg-header_bg rounded text-sm mr-3 mb-3">
              <Link to="/managementFileUpload">Upload Data</Link>
            </span>
            <span className="text-white py-2 px-2 bg-header_bg rounded text-sm ml-4 mr-3 mb-3">
              <Link to="/managementReportDownld">Create Report</Link>
            </span>
          </div>
        </div>
        <div className="p-2 text-xs reportList gridList overflow-x-auto">
          <Table
            {...tableProps}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "Actions":
                      return <CustomCell {...props} />;
                    case "month":
                      return <CustomCell2 {...props} />;
                    case "chargeCodes":
                      return <CustomCell4 {...props} />;
                    case "groupCodes":
                      return <CustomCell5 {...props} />;
                    case "createdAt":
                      return <CustomCell3 {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatch1}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(ManagementReport)
);
